import { render, staticRenderFns } from "./GlobalAudioPlayerController.vue?vue&type=template&id=6f5827c4&"
import script from "./GlobalAudioPlayerController.vue?vue&type=script&lang=ts&"
export * from "./GlobalAudioPlayerController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports